import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Tab, Grid, Button, Header, Checkbox, Form } from 'semantic-ui-react'
import TimeField from './components/TimeField'

import DriverActions from '../../../reducers/driverReducer'

const leftGrid = [
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
]
const rightGrid = ['4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM']
const initTimeSlotData = {
  7: { distance_to_store: 0, distance_travel_per_min: 0 },
  8: { distance_to_store: 0, distance_travel_per_min: 0 },
  9: { distance_to_store: 0, distance_travel_per_min: 0 },
  10: { distance_to_store: 0, distance_travel_per_min: 0 },
  11: { distance_to_store: 0, distance_travel_per_min: 0 },
  12: { distance_to_store: 0, distance_travel_per_min: 0 },
  13: { distance_to_store: 0, distance_travel_per_min: 0 },
  14: { distance_to_store: 0, distance_travel_per_min: 0 },
  15: { distance_to_store: 0, distance_travel_per_min: 0 },
  16: { distance_to_store: 0, distance_travel_per_min: 0 },
  17: { distance_to_store: 0, distance_travel_per_min: 0 },
  18: { distance_to_store: 0, distance_travel_per_min: 0 },
  19: { distance_to_store: 0, distance_travel_per_min: 0 },
  20: { distance_to_store: 0, distance_travel_per_min: 0 },
  21: { distance_to_store: 0, distance_travel_per_min: 0 },
  22: { distance_to_store: 0, distance_travel_per_min: 0 },
  23: { distance_to_store: 0, distance_travel_per_min: 0 },
}

class DriverConfiguration extends React.PureComponent {
  state = {
    readyToPickUp: false,
    timeSlot: initTimeSlotData,
  }

  componentDidMount() {
    const { driverTimeSlot, readyToPickUpFindDriver } = this.props

    if (driverTimeSlot)
      this.setState({ readyToPickUp: readyToPickUpFindDriver, timeSlot: { ...driverTimeSlot } })
  }

  onFieldChange = (hour, field, value) => {
    const { timeSlot } = this.state

    const newTimeSlot = {
      ...timeSlot,
      [hour]: {
        ...timeSlot[hour],
        [field]: Number(value),
      },
    }

    this.setState({ timeSlot: { ...newTimeSlot } })
  }

  onSubmit = () => {
    const { timeSlot, readyToPickUp } = this.state
    const { updateTimeSlot } = this.props

    const confirmation = window.confirm('Are you sure to make changes?')

    const updates = {
      ready_to_pickup_find_driver: readyToPickUp,
      ready_to_pickup_timeslot: timeSlot,
    }

    if (confirmation) {
      updateTimeSlot(updates)
    }
  }

  renderTimeSlotGrid = () => {
    const { timeSlot } = this.state

    return (
      <Grid>
        <Grid.Column width={4}>
          {_.map([...leftGrid, ...rightGrid], (time, key) => (
            <TimeField
              key={key}
              firstRow={key === 0}
              time={time}
              onFieldChange={this.onFieldChange}
              timeSlot={timeSlot}
            />
          ))}
        </Grid.Column>
      </Grid>
    )
  }

  render() {
    const { readyToPickUp } = this.state

    return (
      <Tab.Pane attached={false} className="configuration-tab">
        <Form onSubmit={this.onSubmit}>
          <Header size="large">Ready To Pickup</Header>
          <Form.Field
            control={Checkbox}
            label={`Ready to Pickup blocking from assigning driver is "${readyToPickUp ? 'On' : 'Off'}".`}
            toggle
            onChange={() => this.setState({ readyToPickUp: !readyToPickUp })}
            checked={readyToPickUp}
          />
          <Header size="large">Time Slot</Header>
          {this.renderTimeSlotGrid()}
          <Button type="submit">Save</Button>
        </Form>
      </Tab.Pane>
    )
  }
}

const mapState = ({ drivers }) => ({
  driverTimeSlot: drivers.timeSlot,
  readyToPickUpFindDriver: drivers.readyToPickUp,
})

const mapDispatch = {
  updateTimeSlot: DriverActions.updateTimeSlot,
}

export default connect(
  mapState,
  mapDispatch
)(DriverConfiguration)



// WEBPACK FOOTER //
// ./src/containers/configurations/Driver/index.js